export const rootCss = { fontWeight: "bold" };
